import React, { useEffect, useContext, useState } from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import AlertContext from '../../context/AlertContext'

const Navbar = () => {
  const { showAlert } = useContext(AlertContext)
  const history = useNavigate()
  let location = useLocation();
  const [isScrolled, setIsScrolled] = useState(false);
  const [showDropdown, setShowDropdown] = useState(false);
  const userLoggedIn = localStorage.getItem('token');
  const adminLoggedIn = localStorage.getItem('role')
  const host = process.env.REACT_APP_BACKEND_URL;
  const [userName, setUserName] = useState(() => localStorage.getItem('name') || 'User');

  useEffect(() => {
    if (!userLoggedIn) {
      setUserName('User');
      return;
    }
    const cached = localStorage.getItem('name');
    if (cached) {
      setUserName(cached);
      return;
    }
    if (!host) return;
    const fetchName = async () => {
      try {
        const response = await fetch(`${host}/students/student-data/`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'auth-token': localStorage.getItem('token'),
          },
        });
        if (!response.ok) return;
        const data = await response.json();
        const name = data?.name;
        if (name) {
          localStorage.setItem('name', name);
          setUserName(name);
        }
      } catch {
        /* ignore */
      }
    };
    fetchName();
  }, [userLoggedIn, host]);
  
  const handleLogout = (e) => {
    e.preventDefault();
    // Clear stored credentials and token from localStorage
    localStorage.removeItem('rememberMe');
    localStorage.removeItem('email');
    localStorage.removeItem('password');
    localStorage.removeItem('token');
    localStorage.removeItem('role');
    localStorage.removeItem('expiryTime')
    localStorage.removeItem('name');
    showAlert("Logout successful!", "info");
    history('/login')
  }
  
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setShowDropdown(false);
  }, [location]);
  return (
    <nav className={`navbar navbar-expand-lg navbar-modern ${isScrolled ? 'navbar-scrolled' : ''}`}>
      <div className="container-fluid">
        <Link className="navbar-brand-modern" to="/profile">
          <img src="https://bookbuddy.co.in/wp-content/uploads/2023/02/Background-300x264.png" alt="BookBuddy Logo" className="brand-logo-img" />
          <div className="brand-text-wrapper">
            <span className="brand-text">BookBuddy</span>
            <span className="brand-subtitle">Members</span>
          </div>
        </Link>
        
        <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
          <span className="navbar-toggler-icon"></span>
        </button>
        
        <div className="collapse navbar-collapse" id="navbarSupportedContent">
          <ul className="navbar-nav me-auto mb-2 mb-lg-0">
            {userLoggedIn && (
              <>
                <li className="nav-item">
                  <Link className={`nav-link-modern ${location.pathname === "/" ? "active" : ""}`} to="/">
                    <svg className="nav-icon" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
                      <polyline points="9 22 9 12 15 12 15 22"></polyline>
                    </svg>
                    Home
                  </Link>
                </li>
                <li className="nav-item">
                  <Link className={`nav-link-modern ${location.pathname === "/profile" ? "active" : ""}`} to="/profile">
                    <svg className="nav-icon" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                      <circle cx="12" cy="7" r="4"></circle>
                    </svg>
                    Profile
                  </Link>
                </li>
              </>
            )}
            {(adminLoggedIn === "Admin" || adminLoggedIn === "Superadmin") && (
              <>
                <li className="nav-item">
                  <Link className={`nav-link-modern ${location.pathname === "/allstudents" ? "active" : ""}`} to="/allstudents">
                    <svg className="nav-icon" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
                      <circle cx="9" cy="7" r="4"></circle>
                      <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
                      <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
                    </svg>
                    Students
                  </Link>
                </li>
                <li className="nav-item">
                  <Link className={`nav-link-modern ${location.pathname === "/allseats" ? "active" : ""}`} to="/allseats">
                    <svg className="nav-icon" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
                      <line x1="9" y1="3" x2="9" y2="21"></line>
                    </svg>
                    Seats
                  </Link>
                </li>
              </>
            )}
          </ul>
          
          <div className="navbar-actions">
            {!userLoggedIn ? (
              <>
                <Link to="/login" className="btn-nav btn-nav-outline">
                  Login
                </Link>
                <Link to="/signup" className="btn-nav btn-nav-primary">
                  Sign Up
                </Link>
              </>
            ) : (
              <div className="user-menu">
                <button 
                  className="user-menu-trigger" 
                  onClick={() => setShowDropdown(!showDropdown)}
                  onBlur={() => setTimeout(() => setShowDropdown(false), 200)}
                >
                  <div className="user-avatar">
                    {userName.charAt(0).toUpperCase()}
                  </div>
                  <span className="user-name">{userName}</span>
                  <svg className={`dropdown-arrow ${showDropdown ? 'open' : ''}`} xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <polyline points="6 9 12 15 18 9"></polyline>
                  </svg>
                </button>
                
                {showDropdown && (
                  <div className="user-dropdown">
                    <div className="dropdown-header">
                      <div className="dropdown-user-info">
                        <div className="dropdown-user-name">{userName}</div>
                        <div className="dropdown-user-role">{adminLoggedIn || 'Member'}</div>
                      </div>
                    </div>
                    <div className="dropdown-divider"></div>
                    <Link to="/profile" className="dropdown-item">
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                        <circle cx="12" cy="7" r="4"></circle>
                      </svg>
                      My Profile
                    </Link>
                    <div className="dropdown-divider"></div>
                    <button onClick={handleLogout} className="dropdown-item dropdown-item-danger">
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
                        <polyline points="16 17 21 12 16 7"></polyline>
                        <line x1="21" y1="12" x2="9" y2="12"></line>
                      </svg>
                      Logout
                    </button>
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    </nav>
  )
}

export default Navbar